
import config from "@/assets/config";

import { proyecto } from "@/mixins/proyecto.mixins.js";
import { util } from "@/mixins/util.js";
export default {
  mixins: [proyecto, util],
  layout: "blank",
  head() {
    return {
      title: this.$t("login.title"),
    };
  },
  async asyncData(context) {
    try {
      //Token
      let token_info = {};
      let token = context.app.$cookiz.get("token_cuenta");
      if (token != "" && token != undefined) {
        let url = `${config.api_url}verificar_token_cuenta/${token}`;
        let { data } = await context.app.$axios.get(url);
        token_info = data.info != undefined ? data.info : {};
      }
      return { token_info };
    } catch (error) {
      console.error(error);
    }
  },
  data() {
    return {
      proyecto_id: config.APP.ID,
    };
  },
};
